import { charts } from "./charts/index.js";
import { common } from "./common/index.js";
import { dataDisplay } from "./dataDisplay/index.js";
import { datePickers } from "./datePickers/index.js";
import { feedback } from "./feedback/index.js";
import { inputs } from "./inputs/index.js";
import { navigation } from "./navigation/index.js";
import { surfaces } from "./surfaces/index.js";
import { utils } from "./utils/index.js";
const components = {
  ...common,
  ...dataDisplay,
  ...feedback,
  ...inputs,
  ...navigation,
  ...surfaces,
  ...utils,
  ...datePickers,
  ...charts
};
export {
  components
};
//# sourceMappingURL=index.js.map
